var _circle, _circle2, _circle3, _circle4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVatNotPosted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "SI_4L_stroke",
    cx: 12,
    cy: 12.6,
    r: 7.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "SI_4L_fill_red",
    cx: 12,
    cy: 12.6,
    r: 4.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "SI_4L_fill_red",
    cx: 30,
    cy: 29.7,
    r: 4.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "SI_4L_stroke",
    cx: 30,
    cy: 29.7,
    r: 7.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M10.8 36l20-29.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVatNotPosted);
export default __webpack_public_path__ + "static/media/vat_notPosted.cbdec966c8ca40ce2aed41b3271890be.svg";
export { ForwardRef as ReactComponent };